import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import FilterGroupChips from './FilterGroupChips';
import { translate } from '../../Services/translation';
import { useDispatch } from 'react-redux';
import { clearAllFilters } from '../../Actions/ProductFiltering.action';
import { useMemo } from 'react';
import styled from 'styled-components';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { text } from '../../styling/mixins/typography';

const StyledActiveFilterChip = styled.div`
  gap: 0.8rem;
  margin-bottom: 2.4rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  display: none;

  ${breakpoint('large')} {
    display: flex;
  }

  .clear {
    ${text('small')}
    text-decoration: underline;
    cursor: pointer;
  }
`;

const ActiveFilterChips = () => {
  const dispatch = useDispatch();
  const filters = useTypedSelector((state) => state.productFiltering.filters);
  const hasAnyOptionSelected = useMemo(
      () => filters?.some((f) => f.selectedOptions.length > 0),
    [filters]
    );

  return hasAnyOptionSelected ? (
    <StyledActiveFilterChip>
      {filters.map((g) => (
        <FilterGroupChips key={g.id + 'chips'} filterGroup={g} />
      ))}
      <a className="clear" onClick={() => dispatch(clearAllFilters())}>
        {translate('product-filtering.clear-all-filters')}
      </a>
    </StyledActiveFilterChip>
  ) : null;
};

export default ActiveFilterChips;
